import { render, staticRenderFns } from "./SearchAttr.vue?vue&type=template&id=32f0d5c6&scoped=true&"
import script from "./SearchAttr.vue?vue&type=script&lang=js&"
export * from "./SearchAttr.vue?vue&type=script&lang=js&"
import style0 from "./SearchAttr.vue?vue&type=style&index=0&id=32f0d5c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f0d5c6",
  null
  
)

export default component.exports